import {Pipe, PipeTransform} from "@angular/core";
import {PeerStatus} from "../../model/peerStatus";

@Pipe({name: 'peerStatus'})
export class PeerStatusPipe implements PipeTransform {
    transform(value: any) {
        return PeerStatus[value];
    }
}
